module.exports = __webpack_public_path__ + "img/bb_g3_t_nose-04.af8006f2.svg";